// import logo from './logo.svg';
/* eslint-disable react-hooks/exhaustive-deps */

import React from 'react';
import { observer } from 'mobx-react'; 
import { IntlProvider  } from 'react-intl';

import useLangauge from '../store/models/language/useLanguage';
 
import WrappedRoutes from './wrappedRoutes';
function AppRoutes ({ store }) {
    const  {
        translations,
        getLocaleLang,
    } = useLangauge();
 
    return (
    <IntlProvider
        messages={translations}
        locale={getLocaleLang()}
        defaultLocale="en"
    >
        <WrappedRoutes store={store} />
    </IntlProvider>
    );
}

export default observer(AppRoutes);
